export const GOOGLE_CONNECTION_EXPIRED_ALERT =
  'Your Google connection has expired. Reconnect to restore knowledge base access.'
export const LIVE_DOCUMENTS_UNAVAILABLE_ALERT =
  'One or more knowledge base links are unavailable. Please review and update your knowledge base.'
export const LIVE_DOCUMENT_ACCESS_LOST_TOOLTIP =
  "Can't access this document. Reconnect to use it in your knowledge base."
